
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Alle von der Covid-19-Epidemie betroffenen Staaten verfolgen das gleiche primäre
Ziel: die Verbreitung von Sars-CoV-2 eindämmen und so neue Erkrankungen
verhindern. Während gewisse Länder mittels konsequentem `}<em parentName="p">{`Social Distancing`}</em>{` und
Einschränkung des öffentlichen Lebens deutliche Erfolge verbuchen konnten,
befinden sich andere noch immer in einer Phase der ungebremsten Ausbreitung.`}</p>
    <p>{`Eine ungewohnte Perspektive auf die Fallzahlen bietet der Vergleich der täglich
hinzukommenden Neuinfektionen mit der Anzahl aller bestätigten Fälle: Hier wird
die Verlangsamung des Wachstums deutlicher als bei einer Betrachtung auf der
Zeitachse – wo ein Abwärtstrend vorhanden ist, wird er als steil abfallende
Kurve sichtbar. Die Grafik zeigt natürlich stets nur eine Momentaufnahme; ob der
Erfolg von Dauer ist, wird erst die Zukunft weisen.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;